"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChildOnRegistrationWaitingList = void 0;
const types_1 = require("@hoepel.app/types");
class ChildOnRegistrationWaitingList {
    constructor(props) {
        this.props = props;
    }
    get id() {
        return this.props.id;
    }
    get tenantId() {
        return this.props.tenant;
    }
    get firstName() {
        return this.props.newChild.firstName;
    }
    get lastName() {
        return this.props.newChild.lastName;
    }
    get birthDate() {
        if (this.props.newChild.birthDate == null) {
            return null;
        }
        return types_1.DayDate.fromISO8601(this.props.newChild.birthDate);
    }
    get gender() {
        switch (this.props.newChild.gender) {
            case 'male':
            case 'female':
            case 'other':
                return this.props.newChild.gender;
            default:
                return null;
        }
    }
    get remarks() {
        return this.props.newChild.remarks;
    }
    get createdByParentUid() {
        return this.props.newChild.createdByParentUid;
    }
    get address() {
        return new types_1.Address(this.props.newChild.address);
    }
    get email() {
        return this.props.newChild.email;
    }
    get phoneContacts() {
        return this.props.newChild.phone;
    }
    get uitpasNumber() {
        return this.props.newChild.uitpasNumber || null;
    }
    toProps() {
        return this.props;
    }
    static fromProps(props) {
        return new ChildOnRegistrationWaitingList(props);
    }
    static create(props) {
        return ChildOnRegistrationWaitingList.fromProps(props);
    }
    makeChild(newChildId) {
        return new types_1.Child({
            id: newChildId,
            address: this.address,
            firstName: this.firstName,
            lastName: this.lastName,
            contactPeople: [],
            email: this.email,
            phone: this.phoneContacts,
            remarks: this.remarks,
            birthDate: this.birthDate || undefined,
            gender: this.gender || undefined,
            managedByParents: [this.createdByParentUid],
            uitpasNumber: this.uitpasNumber || undefined,
        });
    }
    mergeWithExistingChild(existingChild) {
        const remarks = existingChild.remarks === ''
            ? this.remarks
            : `${this.remarks}\n\nToegevoegd door speelplein: ${existingChild.remarks}`;
        const mergedChild = existingChild
            .withAddress(this.address)
            .withFirstName(this.firstName)
            .withLastName(this.lastName)
            .withEmail(this.email)
            .withPhoneContact(this.phoneContacts)
            .withManagedByParents([
            ...(existingChild.managedByParents || []),
            this.createdByParentUid,
        ])
            .withRemarks(remarks)
            .withUitpasNumber(this.uitpasNumber || undefined);
        if (this.birthDate == null) {
            return mergedChild;
        }
        return mergedChild.withBirthDate(this.birthDate);
    }
}
exports.ChildOnRegistrationWaitingList = ChildOnRegistrationWaitingList;
//# sourceMappingURL=child-on-registration-waiting-list.js.map